/**
 * Boostrap Modal and Lightbox
 */
(function($){
    var $body = $(document.body);

    function getPopmeModal() {
        var $popme = $('#modal-popme');
        if(!$popme.length){
            var modal_html = '<div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">\
      <div class="modal-dialog">\
        <div class="modal-content">\
          <div class="modal-image"></div>\
          <div class="modal-header">\
            <h4 class="modal-title"></h4>\
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>\
          </div>\
          <div class="modal-body"></div>\
          <div class="modal-footer d-none"></div>\
        </div>\
      </div>\
    </div>';
            $(modal_html).attr('id', 'modal-popme').appendTo($body);

            $popme = $('#modal-popme')

            initPopMeEvents($popme);
        }

        return $popme;
    }

    $(document).ready(function() {
        $('.popme').on('click', function(e) {
            getPopmeModal().modal('show', $(this));
            e.preventDefault();
        })
    });

    $(window).on('load', function() {
        // Set parent iframe modal height
        if ($body.hasClass('body-modal') && self !== top) {
            var $hubspotForm = $body.find('.form-hubspot');
            if (!$hubspotForm.length) {
                setOuterHeight();
            } else {
                // Run timer until hubspot form loaded
                var timer = setInterval(function() {
                    if ($hubspotForm.find('form').hasClass('hs-form')) {
                        setOuterHeight();
                        clearInterval(timer);
                    }
                }, 200);
            }
            function setOuterHeight(){
                var $outer = $('#modal-popme-iframe', window.parent.document);
                $outer.height($(document).height());
            }
        }
    });
    /**
     *
     * @param $popme
     */
    function initPopMeEvents($popme) {
        $popme.on('show.bs.modal', function (e) {
            var $self = $(e.relatedTarget);

            $popme.addClass('modal-loading');

            var modal_class = 'modal-dialog';

            // Sizes, Types, etc. Eg replaces popme-lg with modal-lg for bootstrap
            var classList = $self.attr('class').split(/\s+/);
            for (var i = 0; i < classList.length; i++) {
                var match = classList[i].match(/^popme\-(.*)/);
                if (match) {
                    modal_class += ' modal-' + match[1];
                }
            }

            // purposely over write encase of model reuse
            $popme.find('.modal-dialog').attr('class', modal_class);

            if ($self.data("width") && $self.data("height")) {
                $popme.find('.modal-dialog').css('width', $self.data("width"));
                $popme.find('.modal-body').css('height', $self.data("height"));
            }

            var title = '';
            if ($self.data("title")) {
                title = $self.data("title");
            } else if ($self.attr("title")) {
                title = $self.attr("title");
            }

            if (title) {
                $popme.removeClass('modal-noheader');
                $popme.find('.modal-title').html(title);
            } else {
                $popme.addClass('modal-noheader');
            }

            var content = $self.parent().find('.popme-content').html();
            if (content) {
                $popme.find('.modal-footer').html(content).removeClass('d-none');
            } else {
                $popme.find('.modal-footer').html('').addClass('d-none');
            }


            var href = '';
            if ($self.data("href")) {
                href = $self.data("href");
            } else if ($self.attr('href')) {
                href = $self.attr('href');
            }

            var height;
            if ($self.data("height")) {
                height = $self.data("height");
            } else if ($self.data('size') == 'lg' || $self.data('size') == 'xl' ||
                $self.hasClass('popme-lg') || $self.hasClass('popme-xl') ||
                $self.hasClass('popme-full')) {
                height = 800;
            }
            if (!height) {
                height = 600
            }

            //$popme.css('min-height', height);

            if (href) {
                var isYoutubeRequest = href.indexOf('youtube.com') || href.indexOf('youtube-nocookie.com');

                if ($self.hasClass('popme-iframe') || isYoutubeRequest) {
                    $popme.addClass('modal-hasiframe');

                    if (isYoutubeRequest) {
                        var video_width = 850 //560;
                        var video_height = 473//315;
                        var iframe_html = '<iframe id="modal-popme-iframe" src="" style="margin:0; padding:0; max-width:100%; width:' + video_width + 'px!important; height:' + video_height + 'px; display:block" frameborder="0" frameborder="0" hspace="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>';
                    } else {
                        var iframe_html = '<iframe id="modal-popme-iframe" src="" style="margin:0; padding:0; width:100%; height:' + height + 'px; display:block" frameborder="0" frameborder="0" hspace="0"></iframe>';
                    }

                    $popme.find(".modal-body").addClass('modal-iframe').css('height', 'auto').html(iframe_html);

                    var url = href + (href.indexOf('?') >= 0 ? "&" : '?') + 'output=modal';
                    var $iframe = $('#modal-popme-iframe');

                    $iframe.attr('src', url)

                } else {
                    $popme.removeClass('modal-hasiframe');

                    // Simple request prevent double iframing
                    $.get(href, function (data) {
                        $popme.removeClass('modal-loading');
                        $popme.find(".modal-body").html(data)
                    });
                }
            }
        });

        $popme.on('hide.bs.modal', function () {
            $popme.find(".modal-iframe").empty();
        });

        /**
         * Global Access Close Bootstrap Modal
         * Call from iframe with: window.parent.closeModal();
         */
        window.closeModal = function () {
            $popme.modal('hide');
        };
    }
})(jQuery);
